<section class="carousel-contextual-tabs-shared" [ngClass]="styleClass" *ngIf="(serviceList$ | async)?.length">
  <ng-container *ngFor="let item of serviceList$ | async">
    <div class="box">
      <div class="box-content">
        <div class="box-content__subheading">
          <span>
            {{ translate.currentLang === 'th' ? item.data.subHeading.th : item.data.subHeading.en }}
          </span>
        </div>
        <h3 class="box-content__heading">
          <span>
            {{ translate.currentLang === 'th' ? item.data.heading.th : item.data.heading.en }}
          </span>
        </h3>

        <div class="box-content__menu desktop">
          <div class="box-content__menu--nav">
            <ng-container
              *ngFor="
                let content of translate.currentLang === 'th' ? item.data.contentLists.th : item.data.contentLists.en;
                let i = index
              "
            >
              <div class="nav-bar">
                <div class="nav-bar__list" [ngClass]="{ active: currentSlide === i + 1 }" (click)="goToSlide(i + 1)">
                  <span>{{ content.navbar }}</span>
                </div>
              </div>
            </ng-container>
          </div>
        </div>

        <div class="box-content__navigation mobile">
          <button class="navigation-btn" (click)="actionClickSlide(actionTypeEnum.prev, getContentListLength(item))">
            <i class="fas fa-arrow-left"></i>
          </button>
          <ng-container
            *ngFor="
              let content of translate.currentLang === 'th' ? item.data.contentLists.th : item.data.contentLists.en;
              let i = index
            "
          >
            <div
              class="navigation-content"
              *ngIf="currentSlide === i + 1"
              [ngClass]="{ active: currentSlide === i + 1 }"
            >
              <span>{{ content.navbar }}</span>
            </div>
          </ng-container>
          <button class="navigation-btn" (click)="actionClickSlide(actionTypeEnum.next, getContentListLength(item))">
            <i class="fas fa-arrow-right"></i>
          </button>
        </div>
      </div>

      <div class="box-wrapper">
        <div class="box-wrapper__navigation desktop">
          <button class="navigation-btn" (click)="actionClickSlide(actionTypeEnum.prev, getContentListLength(item))">
            <i class="fas fa-arrow-left"></i>
          </button>
        </div>

        <div class="box-wrapper__block">
          <ng-container
            *ngFor="
              let content of translate.currentLang === 'th' ? item.data.contentLists.th : item.data.contentLists.en;
              let i = index
            "
          >
            <div
              class="box-wrapper__block--element"
              *ngIf="currentSlide === i + 1"
              [ngClass]="{ slide: currentSlide === i + 1 }"
            >
              <div class="element-left">
                <div class="element-left__text">
                  <div class="text-subtitle">
                    <span>{{ content.subTitle }}</span>
                  </div>
                  <div class="text-title">
                    <span>{{ content.title | translate }}</span>
                  </div>
                  <div class="text-detail">
                    <span>{{ content.detail }}</span>
                  </div>
                  <div class="text-btn" *ngIf="content.btnLink">
                    <a [href]="content.btnLink" target="_blank" rel="noopener noreferrer" class="text-btn__layout">
                      <span>{{ content.btnText }}</span>
                      <i class="fas fa-angle-right"></i>
                    </a>
                  </div>

                  <div class="text-btn" *ngIf="content.btnId">
                    <button (click)="scrollToTarget(content.btnId)" class="text-btn__layout">
                      <span>{{ content.btnText }}</span>
                      <i class="fas fa-angle-right"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div class="element-right">
                <div class="element-right__img">
                  <picture>
                    <source [srcset]="content.imageWebp" type="image/webp" />
                    <img [src]="content.image" [alt]="content.subTitle" loading="lazy" class="img-layout" />
                  </picture>
                </div>
              </div>
            </div>
          </ng-container>

          <div class="box-wrapper__dot">
            <ng-container
              *ngFor="
                let content of translate.currentLang === 'th' ? item.data.contentLists.th : item.data.contentLists.en;
                let i = index
              "
            >
              <div class="dot" [ngClass]="{ active: currentSlide === i + 1 }"></div>
            </ng-container>
          </div>
        </div>

        <div class="box-wrapper__navigation desktop">
          <button
            class="navigation-btn"
            (click)="actionClickSlide(actionTypeEnum.next, getContentListLength(item))"
            aria-label="next-slide"
          >
            <i class="fas fa-arrow-right"></i>
          </button>
        </div>
      </div>
    </div>
  </ng-container>
</section>
